import * as React from "react";
import { theme } from "~/theme";

import { rgba } from "polished";
import { format } from "date-fns";

import ceoSignature from "~/assets/certificate/ceo-signature.png";
import footerSponsors from "~/assets/certificate/footer-sponsors.png";
import logo from "~/assets/certificate/logoLiveLighter.png";

import futuraBt from "~/assets/fonts/FuturaBT-Bold.ttf";

/* PDF */
import {
  Document,
  Font,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";

Font.register({ family: "FuturaBT", src: futuraBt });

interface CertificateProps {
  name: string;
  completedDate: number;
}

export const CertificatePdf: React.FC<CertificateProps> = ({
  name,
  completedDate,
}) => (
  <Document>
    <Page size="A4" orientation="landscape" style={pdfStyles.page}>
      <View style={pdfStyles.heading}>
        <Text style={pdfStyles.headingTitle1}>
          LiveLighter Workplace Health Coordinator Training
        </Text>
        <Text style={pdfStyles.headingTitle2}>Certificate of Completion</Text>
      </View>

      <View style={pdfStyles.body}>
        <Text style={pdfStyles.bodyText1}>This is to certify that</Text>
        <Text style={pdfStyles.bodyText2}>{name}</Text>
        <Text style={pdfStyles.bodyText3}>
          Has successfully completed the LiveLighter Workplace Health
          Coordinator Training
        </Text>
        <View style={pdfStyles.modulesBox}>
          <Text style={pdfStyles.moduleText}>
            <Text style={{ fontFamily: "FuturaBT" }}>Module one: </Text>
            Introduction to workplace health
          </Text>
          <Text style={pdfStyles.moduleText}>
            <Text style={{ fontFamily: "FuturaBT" }}>Module two: </Text>
            Motivating staff to be healthy
          </Text>
          <Text style={pdfStyles.moduleText}>
            <Text style={{ fontFamily: "FuturaBT" }}>Module three: </Text>
            Best practice workplace health promotion
          </Text>
          <Text style={pdfStyles.moduleText}>
            <Text style={{ fontFamily: "FuturaBT" }}>Module four: </Text>
            Planning your program
          </Text>
        </View>

        <View style={pdfStyles.completionBox}>
          <View
            style={{
              display: "flex",
              flexDirection: "column",
              alignSelf: "center",
              width: "40%",
            }}
          >
            <Text
              style={{
                fontFamily: "FuturaBT",

                fontSize: "16pt",
              }}
            >
              Date of completion
            </Text>
            <Text>{format(completedDate, "dd MMM yyyy")}</Text>
          </View>
          <View
            style={{ display: "flex", flexDirection: "column", width: "50%" }}
          >
            <Image style={pdfStyles.signature} src={ceoSignature} />
            <Text
              style={{
                fontFamily: "FuturaBT",
                fontSize: "14pt",
              }}
            >
              Ashley Reid
            </Text>
            <Text style={{ fontSize: "14pt" }}>
              Chief Executive Officer, Cancer Council Western Australia
            </Text>
          </View>
        </View>
      </View>

      <View style={pdfStyles.footer}>
        <View
          style={{ display: "flex", flexDirection: "column", width: "40%" }}
        >
          <Image style={{ width: 300 }} src={footerSponsors} />
        </View>
        <Image style={{ width: 150 }} src={logo} />
      </View>
    </Page>
  </Document>
);

const pdfStyles = StyleSheet.create({
  page: {
    display: "flex",
    flexDirection: "column",
    alignContent: "center",
    margin: "2vw",
    height: "96vw",
  },

  heading: {
    backgroundColor: theme.info,
    padding: 20,
    width: "96vw",
    marginBottom: 20,
  },
  headingTitle1: {
    fontFamily: "FuturaBT",
    fontSize: "22pt",
    color: "white",
    textAlign: "center",
    marginBottom: 10,
  },
  headingTitle2: {
    fontFamily: "FuturaBT",
    fontSize: "40pt",
    letterSpacing: "0.3vw",
    color: theme.gold,
    textAlign: "center",
    textTransform: "uppercase",
  },

  body: {
    position: "relative",
    width: "96vw",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignContent: "center",
    textAlign: "center",
  },
  bodyText1: { marginBottom: 15, fontSize: "14pt" },
  bodyText2: {
    fontFamily: "FuturaBT",
    marginBottom: 20,
    color: theme.info,
    fontSize: "24pt",
  },
  bodyText3: { marginBottom: 20 },

  modulesBox: {
    width: "50%",
    margin: "0 auto",
    display: "flex",
    alignSelf: "center",
    padding: "20px 0",
    marginBottom: 10,
    backgroundColor: `${rgba(theme.gold, 0.2)}`,
  },
  moduleText: {
    fontSize: "14pt",
    marginBottom: 10,
    color: theme.primary,
  },

  completionBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignContent: "center",
    width: "100%",
  },
  signature: {
    display: "flex",
    alignSelf: "center",
    width: 100,
  },

  footer: {
    width: "96vw",
    position: "absolute",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "2vw",
    bottom: "2vw",
    left: 0,
    right: 0,
  },
});
